import { getModelFamily } from "../modelProfiles";

const CACHE_KEY = "videoStudio_poyo_pricing_v1";

export async function fetchPoyoPricing() {
  const cached = localStorage.getItem(CACHE_KEY);
  if (cached) {
    try {
      return JSON.parse(cached);
    } catch {
      // ignore
    }
  }

  const res = await fetch("/api/web/get_poyo_pricing", { method: "GET" });
  const json = await res.json().catch(() => null);
  if (json?.success && json?.data) {
    localStorage.setItem(CACHE_KEY, JSON.stringify(json.data));
    return json.data;
  }
  return null;
}

function normResolution(resolution) {
  const r = String(resolution || "").toLowerCase();
  if (r.includes("4k")) return "4k";
  if (r.includes("1080")) return "1080p";
  if (r.includes("720")) return "720p";
  if (r.includes("480")) return "480p";
  if (r.includes("768")) return "768p";
  return "1080p";
}

function getVideoVendorUsd(poyoPricing, form) {
  const model = form.model;
  const family = getModelFamily(model);
  const duration = Number(form.duration) || 0;
  const resKey = normResolution(form.motionResolution || form.hailuoResolution || form.resolution);
  const sound = form.sound !== false;

  const video = poyoPricing?.poyo?.video || {};

  // Kling 3.0 (tiered + audio)
  if (family === "kling-3") {
    const conf = video["kling-3.0"];
    const tier = conf?.tiers?.[resKey] || conf?.tiers?.["1080p"];
    if (!tier) return null;
    const usdPerS = sound ? tier.with_audio_usd_per_s : tier.no_audio_usd_per_s;
    if (!usdPerS) return null;
    return duration * Number(usdPerS);
  }

  // Kling motion control (tiered, no audio switch in pricing)
  if (family === "kling-motion-control") {
    const conf = video["kling-3.0-motion-control"];
    const tier = conf?.tiers?.[resKey] || conf?.tiers?.["720p"];
    const usdPerS = tier?.usd_per_s;
    if (!usdPerS) return null;
    return duration * Number(usdPerS);
  }

  // Wan 2.7 (tiered)
  if (family === "wan") {
    const conf = video["wan-2.7"];
    const tier = conf?.tiers?.[resKey] || conf?.tiers?.["720p"];
    const usdPerS = tier?.usd_per_s;
    if (!usdPerS) return null;
    return duration * Number(usdPerS);
  }

  return null;
}

export function estimateRetailUsd(poyoPricing, form) {
  if (!poyoPricing) return null;
  const vendor = getVideoVendorUsd(poyoPricing, form);
  if (vendor == null) return null;

  const baseMult = Number(poyoPricing?.retail?.multiplier) || 1;
  const baseFlat = Number(poyoPricing?.retail?.flat_fee_usd) || 0;
  const overrides = poyoPricing?.retail?.perModelOverrides || {};
  const modelOverride = overrides?.[form.model] || overrides?.[getModelFamily(form.model)] || null;
  const mult = modelOverride?.multiplier != null ? Number(modelOverride.multiplier) : baseMult;
  const flat = modelOverride?.flat_fee_usd != null ? Number(modelOverride.flat_fee_usd) : baseFlat;

  const retail = vendor * mult + flat;
  return retail >= 0 ? retail : null;
}

